import { useNavigate } from "react-router-dom";

import { Button } from "@mui/material";
import { PageContainer } from "@/features/ui";

import { PromotionForm } from "@/features/promotions";
import { apiClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";

export const CreatePromotion = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async (payload) => {
    try {
      await apiClient.post("promotions", payload);
      navigate(-1);
    } catch (error) {
      showSnackbar(
        getErrorMessage(error, "Gagal membuat promosi"),
      );
    }
  };

  return (
    <PageContainer
      maxWidth="xl"
      title="Tambah Promosi"
      breadcrumbs={[
        { title: "Promosi", path: "/setting/promotions" },
        { title: "Tambah Promosi" },
      ]}
    >
      <PromotionForm
        onSubmit={handleSubmit}
        renderActionButton={({ isSubmitting }) => (
          <Button type="submit" variant="contained" loading={isSubmitting}>
            Tambah
          </Button>
        )}
      />
    </PageContainer>
  );
};
